// Maps URL slugs (from route params) to medscout_object_type values.
// Existing types (hcp, clinic, center) map to themselves; site-of-care needs translation.
export const entityTypeSlugMap: Record<string, string> = {
  hcp: 'hcp',
  clinic: 'clinic',
  center: 'center',
  'site-of-care': 'site_of_care',
};

export const medscoutOptions = [
  { label: 'Center', value: 'Center' },
  { label: 'Clinic', value: 'Clinic' },
  { label: 'HCP', value: 'HCP' },
  { label: 'Site of Care', value: 'site_of_care' },
  { label: 'Activity', value: 'Activity' },
];

export const inputOptions = [
  { label: 'Checkbox', value: 'BOOLEAN' },
  { label: 'Number', value: 'INTEGER' },
  { label: 'Select', value: 'SELECTOR' },
  { label: 'Date', value: 'DATE' },
  { label: 'Text', value: 'STRING' },
  //TODO: this will require a section to add options, placed in nice to have section.
  // { label: 'AutoComplete', value: 'STRING_WITH_SUGGESTIONS' },
];

// if lookup is true, then the object can be used for lookup mapping
// if mapping is true, then the object can be used for a new mapping
export const crmOptions = {
  salesforce: [
    { label: 'Account', value: 'Account', lookup: true, mapping: true },
    { label: 'Contact', value: 'Contact', lookup: true, mapping: true },
    { label: 'Lead', value: 'Lead', lookup: true, mapping: true },
    { label: 'Opportunity', value: 'Opportunity', lookup: true, mapping: true },
    { label: 'Record Type', value: 'RecordType', lookup: true, mapping: false },
    { label: 'User', value: 'User', lookup: true, mapping: false },
    { label: 'Note', value: 'Note', lookup: true, mapping: true },
  ],
  hubspot: [
    { label: 'Company', value: 'Company', lookup: true, mapping: true },
    { label: 'Contact', value: 'Contact', lookup: true, mapping: true },
    { label: 'Deal', value: 'Deal', lookup: true, mapping: true },
    { label: 'Notes', value: 'Notes', lookup: true, mapping: true },
  ],
  pipedrive: [
    { label: 'Contact', value: 'Contact', lookup: true, mapping: true },
    { label: 'Deal', value: 'Deal', lookup: true, mapping: true },
    { label: 'Lead', value: 'Lead', lookup: true, mapping: true },
    { label: 'People', value: 'People', lookup: true, mapping: true },
    {
      label: 'Organization',
      value: 'Organization',
      lookup: true,
      mapping: true,
    },
  ],
  microsoftdynamics: [
    { label: 'Account', value: 'account', lookup: true, mapping: true },
    { label: 'Contact', value: 'contact', lookup: true, mapping: true },
    { label: 'Lead', value: 'lead', lookup: true, mapping: true },
    { label: 'Opportunity', value: 'opportunity', lookup: true, mapping: true },
    { label: 'User', value: 'systemuser', lookup: true, mapping: false },
    { label: 'Note', value: 'annotation', lookup: true, mapping: true },
  ],
  zohocrm: [
    { label: 'Accounts', value: 'Accounts', lookup: true, mapping: true },
    { label: 'Contacts', value: 'Contacts', lookup: true, mapping: true },
    { label: 'Deals', value: 'Deals', lookup: true, mapping: true },
    { label: 'Leads', value: 'Leads', lookup: true, mapping: true },
  ],
};

// Map of Note-type object values for each CRM
export const noteObjectTypes = {
  salesforce: ['Note'],
  hubspot: ['Notes'],
  pipedrive: [],
  microsoftdynamics: ['annotation'],
  zohocrm: [],
};

/**
 * Filters CRM options to only include Note-type objects for a given integration
 * @param integration - The CRM integration name
 * @returns Filtered array containing only Note-type CRM objects
 */
export const getNoteOptionsForCRM = (integration: string) => {
  const lowerIntegration = integration?.toLowerCase();
  const allOptions = crmOptions[lowerIntegration] || [];
  const noteValues = noteObjectTypes[lowerIntegration] || [];
  return allOptions.filter((option: { value: string }) =>
    noteValues.includes(option.value)
  );
};

export const optionTypeMap = {
  crm_lookup: 'user_input_lookup',
  user_input: 'user_input_custom',
};

// Hospital-system attribute secondary-input sub-selector (hospital_system_name /
// hospital_system_idn). A saved mapping must not carry a null system_type; when editing an
// existing option that predates this field, default it to Parent (CORP).
export const SYSTEM_TYPE_CODE = 'system_type';
export const DEFAULT_SYSTEM_TYPE = 'CORP';

